import request from '@/utils/request'

export function sendSms(data) {
  return request({
    url: '/sms/send',
    method: 'post',
    data
  })
}
